// extracted by mini-css-extract-plugin
export default {"root":"RjABt4","iframeHolder":"ApaTM4","iframe":"Z8YsjS"};